import { PlayerChip, PlayerSwitch } from '../ui';

/**
 * RosterStrip — the players in a live game as full PlayerChips + joined count.
 * Today the relay only carries the session owner, so the roster is P1; when session:roster
 * arrives (multiplayer relay) the same slots array fills in: [{ slot, name, state, guest, tracker, movement }].
 * Clicking a present player focuses the dashboard on them (only meaningful with 2+ players).
 */
export default function RosterStrip({ slots, focus, onFocus }) {
    const present = slots.filter((s) => s.state === 'joined' || s.state === 'lost');
    const guests = slots.some((s) => s.guest && s.state !== 'empty');
    const multi = present.length > 1;
    return (
        <section aria-label="Players" className="ls-players">
            <div className="ls-players__head">
                <span className="eg-caps-15" style={{ fontWeight: 700 }}>Players</span>
                <span className="eg-small eg-secondary" style={{ fontWeight: 600 }}>
                    {present.length} of {slots.length} joined{guests ? ' · guests aren’t recorded' : ''}
                </span>
            </div>
            <div className="ls-roster">
                {slots.map((s) => (
                    <PlayerChip
                        key={s.slot}
                        variant="full"
                        slot={s.slot}
                        name={s.name}
                        state={s.state}
                        guest={s.guest}
                        tracker={s.tracker}
                        movement={s.movement}
                        selected={multi && focus === s.slot}
                        onClick={multi && (s.state === 'joined' || s.state === 'lost') ? () => onFocus(focus === s.slot ? 'all' : s.slot) : undefined}
                    />
                ))}
            </div>
            {multi ? (
                <div className="ls-focus">
                    <span className="eg-caps-14 eg-secondary">Focus</span>
                    <PlayerSwitch slots={present.map((s) => s.slot)} value={focus} onChange={onFocus} />
                </div>
            ) : null}
        </section>
    );
}
